import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';

import analyticsReducer from 'redux/analytics';
import commonReducer from 'redux/common';
import usersReducer from 'redux/users';
import linksReducer from 'redux/links';
import settingsReducer from 'redux/settings';
import billingReducer from 'redux/billing';
import themesReducer from 'redux/themes';
import earningsReducer from 'redux/earnings';
import catalogReducer from 'redux/catalog';
import emailSignupGenerator from 'redux/signup-generator';
import integrationsReducer from 'redux/integrations';
import musicLinksReducer from 'redux/music-links';
import highlightsReducer from 'redux/highlights';
import anonymousMessagesReducer from 'redux/anonymous-messages';
import imageSlidersReducer from 'redux/image-sliders';
import socialReducer from 'redux/social';
import commerceReducer from 'redux/commerce';
import cryptoLinksReducer from 'redux/crypto-links';
import locationLinksReducer from 'redux/location-links';
import menuLinksReducer from 'redux/menu-links';

export default combineReducers({
  analyticsReducer,
  commonReducer,
  usersReducer,
  settingsReducer,
  linksReducer,
  billingReducer,
  themesReducer,
  earningsReducer,
  catalogReducer,
  emailSignupGenerator,
  integrationsReducer,
  musicLinksReducer,
  highlightsReducer,
  anonymousMessagesReducer,
  imageSlidersReducer,
  socialReducer,
  commerceReducer,
  cryptoLinksReducer,
  locationLinksReducer,
  menuLinksReducer,
  form: formReducer,
});
